import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import type { Locale } from "@/components/Seo";

const LANGUAGES: { code: Locale; label: string; path: string; flag: string }[] = [
  { code: "en", label: "English", path: "/", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", path: "/de", flag: "🇩🇪" },
  { code: "fr", label: "Français", path: "/fr", flag: "🇫🇷" },
  { code: "es", label: "Español", path: "/es", flag: "🇪🇸" },
  { code: "et", label: "Eesti", path: "/et", flag: "🇪🇪" },
  { code: "fi", label: "Suomi", path: "/fi", flag: "🇫🇮" },
];

const LanguageSwitcher = ({ current }: { current: Locale }) => {
  const active = LANGUAGES.find((l) => l.code === current) ?? LANGUAGES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
        <Globe size={14} />
        <span>{active.flag} {active.label}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGUAGES.map((l) => (
          <DropdownMenuItem key={l.code} asChild>
            <Link to={l.path}>
              <span className="mr-2">{l.flag}</span>
              {l.label}
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;